import React from "react";

export default () => (
  <section>
    <h2>Services &amp; Fees</h2>
    <p>
      Congratulations! I would be happy to assist you in creating your own
      ceremony and writing your own readings and/or vows. We can work together
      in person, over the phone, or via email to develop a ceremony that meets
      your every wish. Following your ceremony, you would receive a copy of the
      entire ceremony for you to save or to scrapbook your memories.
      Additionally, I will personally ensure that all marriage license documents
      are appropriately filed and mailed to the county as required.
    </p>
    <p>
      Ceremonies: (Includes a brief rehearsal run-through, 1-2 hours prior to
      the actual event)
    </p>
    <ul>
      <li>Monday – Thursday $250</li>
      <li>Friday – Sunday $300</li>
    </ul>
    <p>Separate Rehearsal: (optional)</p>
    <ul>
      <li>Monday – Friday $50</li>
      <li>Saturday – Sunday $100</li>
    </ul>
    <p>
      Please contact me for a complimentary consultation to discuss your
      ceremony plans and for us to get to know each other. Future planning
      meetings can take place in person, over the phone, or via email.
    </p>
    <p>
      Additional costs may be needed if the rehearsal and/or ceremony are held
      outside of King and Pierce Counties or if parking fees are required. A 50%
      deposit is required to reserve your scheduled wedding/commitment ceremony
      date. The remaining balance will need to be paid on or prior to the actual
      ceremony date.
    </p>
  </section>
);
